import s from './Page.styles';

export default s.PageMenu;
